export const TKeyExtension = {
  EXTENSION_GUIDE_TITLE: "EXTENSION_GUIDE_TITLE",
  EXTENSION_GUIDE_INTRO: "EXTENSION_GUIDE_INTRO",
  EXTENSION_GUIDE_STEP_1: "EXTENSION_GUIDE_STEP_1",
  EXTENSION_GUIDE_STEP_2: "EXTENSION_GUIDE_STEP_2",
  EXTENSION_GUIDE_STEP_3: "EXTENSION_GUIDE_STEP_3",
  EXTENSION_GUIDE_STEP_4: "EXTENSION_GUIDE_STEP_4",
  EXTENSION_GUIDE_INSTALL: "EXTENSION_GUIDE_INSTALL",
  EXTENSION_GUIDE_FEATURES_TITLE: "EXTENSION_GUIDE_FEATURES_TITLE",
  EXTENSION_FEATURE_CALLS_TITLE: "EXTENSION_FEATURE_CALLS_TITLE",
  EXTENSION_FEATURE_CALLS_DESC: "EXTENSION_FEATURE_CALLS_DESC",
  EXTENSION_FEATURE_EXTRACT_TITLE: "EXTENSION_FEATURE_EXTRACT_TITLE",
  EXTENSION_FEATURE_EXTRACT_DESC: "EXTENSION_FEATURE_EXTRACT_DESC",
  EXTENSION_FEATURE_PROSPECTS_TITLE: "EXTENSION_FEATURE_PROSPECTS_TITLE",
  EXTENSION_FEATURE_PROSPECTS_DESC: "EXTENSION_FEATURE_PROSPECTS_DESC",
} as const;
